import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { StepContent } from "../../styles/StyledComponents";
import {
  PREMIO_ANNUALE,
  STATUS_LAVORATIVO,
  RELAZIONI_BENEFICIARIO,
} from "../../constants";

const Step5Riepilogo = ({ formData }) => {
  const getStatusLabel = (value) => {
    const status = STATUS_LAVORATIVO.find((s) => s.value === value);
    return status ? status.label : "";
  };

  const getRelazioneLabel = (value) => {
    const relazione = RELAZIONI_BENEFICIARIO.find((r) => r.value === value);
    return relazione ? relazione.label : "";
  };

  return (
    <StepContent>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #4caf50, #66bb6a)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            mb: 2,
          }}
        >
          <AssignmentTurnedInRoundedIcon
            sx={{ fontSize: 40, color: "white" }}
          />
        </Box>
      </Box>

      {/* Prezzo Polizza */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #1976d2, #42a5f5)",
          color: "white",
          borderRadius: 3,
          p: 4,
          mb: 3,
          position: "relative",
        }}
      >
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Polizza IPA Assistance
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9, mb: 3 }}>
          Alta collocazione lavorativa
        </Typography>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
          <Typography variant="h2" fontWeight={700}>
            € {PREMIO_ANNUALE}
          </Typography>
          <Typography variant="h6">/anno</Typography>
        </Box>
        <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
          Pagamento unico annuale
        </Typography>
      </Box>

      {/* Assicurato */}
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
          <PersonRoundedIcon sx={{ color: "#673ab7", fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600}>
            Assicurato
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Nome Completo
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formData.nome} {formData.cognome}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Data Nascita
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formData.dataNascita
                ? new Date(formData.dataNascita).toLocaleDateString("it-IT")
                : ""}{" "}
              ({formData.sesso})
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Email
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formData.email}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Telefono
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formData.telefono}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Situazione Lavorativa */}
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <WorkRoundedIcon sx={{ color: "#e91e63", fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600}>
            Situazione Lavorativa
          </Typography>
        </Box>
        <Typography variant="caption" color="text.secondary">
          Status
        </Typography>
        <Typography variant="body1" fontWeight={600}>
          {getStatusLabel(formData.statusLavorativo)}
        </Typography>
      </Box>

      {/* Beneficiario Designato */}
      {formData.hasBeneficiario && (
        <Box
          sx={{
            border: (theme) =>
              `2px solid ${
                theme.palette.mode === "light" ? "#ffb74d" : "#ff9800"
              }`,
            borderRadius: 2,
            p: 3,
            mb: 3,
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? "#fff8e1"
                : "rgba(255, 152, 0, 0.05)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
            <FavoriteRoundedIcon sx={{ color: "#e91e63", fontSize: 28 }} />
            <Typography variant="h6" fontWeight={600}>
              Beneficiario Designato
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">
                Nome
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {formData.nomeBeneficiario} {formData.cognomeBeneficiario}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">
                Relazione
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {getRelazioneLabel(formData.relazioneBeneficiario)}
              </Typography>
            </Grid>
            {formData.emailBeneficiario && (
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary">
                  Email
                </Typography>
                <Typography variant="body1" fontWeight={600}>
                  {formData.emailBeneficiario}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      )}

      {/* Coperture Assicurative */}
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
          <ShieldRoundedIcon sx={{ color: "#2196f3", fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600}>
            Coperture Assicurative
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {formData.protezioneStandard && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
              <Typography variant="body2">
                Decesso accidentale: €50.000
              </Typography>
            </Box>
          )}
          {formData.protezionePotenziata && (
            <>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <CheckCircleRoundedIcon
                  sx={{ color: "#4caf50", fontSize: 20 }}
                />
                <Typography variant="body2">
                  Invalidità permanente: €50.000
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <CheckCircleRoundedIcon
                  sx={{ color: "#4caf50", fontSize: 20 }}
                />
                <Typography variant="body2">
                  Inabilità temporanea: €1.000/mese
                </Typography>
              </Box>
            </>
          )}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
            <Typography variant="body2">Protezione Bollette: €1.000</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
            <Typography variant="body2">Protezione Reddito: €1.000</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
            <Typography variant="body2">Assistenza legale inclusa</Typography>
          </Box>
        </Box>
      </Box>

      {/* Date Importanti */}
      <Box
        sx={{
          border: (theme) =>
            `2px solid ${
              theme.palette.mode === "light" ? "#ffb74d" : "#ff9800"
            }`,
          borderRadius: 2,
          p: 3,
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#fff8e1"
              : "rgba(255, 152, 0, 0.05)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
          <CalendarMonthRoundedIcon sx={{ color: "#ff9800", fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600}>
            Date Importanti
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Inizio copertura:
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {new Date().toLocaleDateString("it-IT", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Prossimo rinnovo:
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {new Date(
                new Date().setFullYear(new Date().getFullYear() + 1),
              ).toLocaleDateString("it-IT", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </StepContent>
  );
};

export default Step5Riepilogo;
